import SmallHexagon from '@public/images/smallHexagon.svg'
import { GraySection } from '@ui/sections/GraySection'

import { GraySectionWrapper, SmallHexagonWrapper } from './styles'
import type { WorkWithUsSectionProps } from './types'

export function WorkWithUsSection({
  children = undefined,
  title = "Let's work with Us!",
  subtitle = '',
  buttonText = 'Send',
  hexagon = false,
  textWidth = 'fit-content',
  textTransform = 'initial',
  ...props
}: WorkWithUsSectionProps) {
  return (
    <GraySectionWrapper className="wrapper">
      <SmallHexagonWrapper>
        {hexagon && <SmallHexagon className="hexagon-image" />}
      </SmallHexagonWrapper>
      <GraySection
        id="get-in-touch-btn"
        className="content"
        title={title}
        subtitle={subtitle}
        buttonLabel={buttonText}
        textWidth={textWidth}
        textTransform={textTransform}
        {...props}
      >
        {children}
      </GraySection>
    </GraySectionWrapper>
  )
}
